<swiper-container autoplay="true" loop="true" slides-per-view="1">
  <swiper-slide lazy="false"
    ><a routerLink="/search">Free Shipping on Orders over $99</a></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',bestSellersNo]"
      >You Look Beautiful</a
    ></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',newArrivalsNo]"
      >Welcome to Pink Soul</a
    ></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',bestSellersNo]"
      >Discover Your Unique Style</a
    ></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',newArrivalsNo]"
      >New Arrivals Just for You</a
    ></swiper-slide
  >
</swiper-container>
